// src/apiService.js
import axios from "axios";

const BASE_URL = "/api";

const api = axios.create({
  baseURL: BASE_URL,
});

export const getClientByEmail = async (email) => {
  const res = await api.get(`/clients/?email=${encodeURIComponent(email)}`);
  return res.data;
};

export const getClientProfile = async (clientId) => {
  const res = await api.get(`/clients/${clientId}/profile`);
  return res.data;
};

// export const updateClientProfile = async (clientId, formData) => {
//   const res = await api.put(`/clients/${clientId}/profile`, formData);
//   return res.data;
// };

export const updateClientProfile = async (clientId, data) => {
  // Convert FormData to plain object if needed
  const payload = data instanceof FormData
    ? Object.fromEntries(data.entries())
    : data;

  const res = await api.put(`/clients/${clientId}/profile`, payload, {
    headers: { "Content-Type": "application/json" }
  });
  return res.data;
};

export const getSuggestions = async (clientId, count = 50) => {
  const res = await api.get(`/clients/${clientId}/suggestions?count=${count}`);
  return res.data;
};

export const getClientLists = async (clientId) => {
  const res = await api.get(`/clients/${clientId}/lists`);
  return res.data;
};

export const putClientInList = async (clientId, listId) => {
  const formData = new FormData();
  formData.append("client_list", listId);
  const res = await api.put(`/clients/${clientId}/lists`, formData);
  return res.data;
};

// Note: getPaidCandidates now only uses womanId and needed.
export const getPaidCandidates = async (womanId, needed) => {
  const res = await api.get(`/paid-candidates?womanId=${womanId}&needed=${needed}`);
  return res.data;
};

export const createClientMatch = async (clientId, candidateId, groupId) => {
  const formData = new FormData();
  formData.append("match", candidateId);
  formData.append("group", groupId);
  const res = await api.post(`/clients/${clientId}/matches`, formData);
  return res.data;
};
